import { Injectable, inject } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppSettings {
  private breakpointObserver = inject(BreakpointObserver);

  // Signal global reactivo para detectar viewport móvil (<= 767.98px)
  readonly isMobile = toSignal(
    this.breakpointObserver.observe('(max-width: 767.98px)').pipe(
      map(state => state.matches)
    ),
    { initialValue: typeof window !== 'undefined' ? window.innerWidth <= 767 : false }
  );

  public appTheme: string = '';
  public appCover: string = '';
  public appDarkMode: boolean = false;

  /** null: seguir el navegador. true/false: elección guardada del interruptor. */
  explicitDarkMode(): boolean | null {
    const stored = localStorage.getItem('appDarkMode');
    if (stored === 'true') return true;
    if (stored === 'false') return false;
    return null;
  }

  browserPrefersDark(): boolean {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  resolvedDarkMode(): boolean {
    const explicit = this.explicitDarkMode();
    return explicit === null ? this.browserPrefersDark() : explicit;
  }
  public appEmpty: boolean = false;
  public appGradientEnabled: boolean = false;
  public appBodyWhite: boolean = false;
  public appThemePanelNone: boolean = false;

  public appBoxedLayout: boolean = false;
  public appHeaderNone: boolean = false;
  public appHeaderFixed: boolean = true;
  public appHeaderInverse: boolean = false;
  public appHeaderMegaMenu: boolean = false;
  public appHeaderLanguageBar: boolean = false;
  public appHeaderMegaMenuMobileToggled: boolean = false;
  public appTopMenu: boolean = false;
  public appFooter: boolean = false;

  public appSidebarEnd: boolean = false;
  public appSidebarTwo: boolean = false;
  public appSidebarNone: boolean = false;
  public appSidebarGrid: boolean = false;
  public appSidebarWide: boolean = false;
  public appSidebarLight: boolean = true;
  public appSidebarFixed: boolean = true;
  public appSidebarSearch: boolean = false;
  public appSidebarMinified: boolean = false;
  public appSidebarCollapsed: boolean = false;
  public appSidebarTransparent: boolean = false;
  public appSidebarMobileToggled: boolean = false;
  public appSidebarRightCollapsed: boolean = false;
  public appSidebarEndToggled: boolean = false;
  public appSidebarEndMobileToggled: boolean = false;

  public appContentClass: string = '';
  public appContentFullHeight: boolean = false;
  public appContentFullWidth: boolean = false;
}